
import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { ClientproxyApiClient } from "../clients/ClientproxyApiClient";
import { IComponentInfoResult } from "./models/IComponentInfoResult";
import { IGetComponentInfoWithStatusParameters } from "./models/IGetComponentInfoWithStatusParameters";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class ComponentListService
{
	private readonly url: string;

	constructor(private readonly apiClient: ClientproxyApiClient)
    {
        this.url = "componentlist";
    }

    async getComponentInfoWithIndicators(parameters: IGetComponentInfoWithStatusParameters): Promise<IComponentInfoResult>
    {
        return await this.apiClient.post<IComponentInfoResult>(`${this.url}/info`,{},JSON.stringify(parameters));
    }
}
